export const getState = state => state.modals.open;
